module.exports = __webpack_public_path__ + "9779d9a1/img/revit-icon.5ff0d581.svg";